// Stripe Checkout refuses to render inside an iframe (e.g. the preview frame): break out of it.
const PENDING_KEY = "findloop_pending_checkout";
const PENDING_TTL_MS = 24 * 3600 * 1000;

const withParam = (path, key, val) => {
  const [base, q = ""] = path.split("?");
  const sp = new URLSearchParams(q);
  sp.set(key, val);
  return `${base}?${sp.toString()}`;
};

// Remember the Stripe session so a cancelled / abandoned payment can be resumed.
export function rememberCheckout(url, returnTo) {
  const m = /(cs_(?:test|live)_[A-Za-z0-9]+)/.exec(url || "");
  if (!m) return;
  const back = returnTo || `${window.location.pathname}${window.location.search}`;
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify({ sid: m[1], url, returnTo: withParam(back, "payment_cancelled", "1"), at: Date.now() }));
  } catch { /* storage unavailable */ }
}

export function getPendingCheckout() {
  try {
    const p = JSON.parse(localStorage.getItem(PENDING_KEY) || "null");
    if (!p || Date.now() - p.at > PENDING_TTL_MS) return null;
    return p;
  } catch { return null; }
}

export function clearPendingCheckout() {
  try { localStorage.removeItem(PENDING_KEY); } catch { /* ignore */ }
}

export function goToCheckout(url, { returnTo } = {}) {
  if (!url) return;
  rememberCheckout(url, returnTo);
  let framed = false;
  try { framed = window.self !== window.top; } catch { framed = true; }
  if (!framed) { window.location.href = url; return; }
  try { window.top.location.href = url; return; } catch { /* cross-origin top: fall through */ }
  const w = window.open(url, "_blank");
  if (!w) window.location.href = url;
}
